import script from "./VersionHistory.vue?vue&type=script&setup=true&lang=js"
export * from "./VersionHistory.vue?vue&type=script&setup=true&lang=js"

import "./VersionHistory.vue?vue&type=style&index=0&id=6c57e591&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c57e591"]])

export default __exports__